import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  inviteId: string;
}

export function useSendProjectOnboardingReminder() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ projectId, inviteId }: Params) =>
      post({
        url: `/projects/${projectId}/team/invites/${inviteId}/onboarding-reminder`,
      }),
    onSuccess: (_, { projectId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getProjectTeamInvites(projectId),
      });
    },
  });

  const sendProjectOnboardingReminder = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    sendProjectOnboardingReminder,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
